import { useEffect, useSyncExternalStore } from 'react';

const OPEN = 'easylearning:talk-open';
let gameBars = 0;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((l) => l());

let boardOpen = false;
const openListeners = new Set<() => void>();
const pauses: { from: number; to: number | null }[] = [];

export function setTalkBoardOpen(open: boolean) {
  if (open === boardOpen) return;
  boardOpen = open;
  const now = performance.now();
  if (open) pauses.push({ from: now, to: null });
  else {
    const last = pauses[pauses.length - 1];
    if (last && last.to === null) last.to = now;
  }
  if (pauses.length > 100) pauses.shift();
  openListeners.forEach((l) => l());
}

export function isTalkBoardOpen() {
  return boardOpen;
}

export function useTalkBoardOpen() {
  return useSyncExternalStore(
    (l) => { openListeners.add(l); return () => openListeners.delete(l); },
    () => boardOpen,
  );
}

export function pausedMsSince(start: number): number {
  const now = performance.now();
  return pauses.reduce((sum, p) => sum + Math.max(0, Math.min(p.to ?? now, now) - Math.max(p.from, start)), 0);
}

export function openTalkBoard() {
  window.dispatchEvent(new Event(OPEN));
}

export function onTalkOpen(fn: () => void) {
  window.addEventListener(OPEN, fn);
  return () => window.removeEventListener(OPEN, fn);
}

export function useGameBarTalk(active: boolean) {
  useEffect(() => {
    if (!active) return;
    gameBars += 1;
    notify();
    return () => { gameBars -= 1; notify(); };
  }, [active]);
}

export function useGameBarShown() {
  return useSyncExternalStore(
    (l) => { listeners.add(l); return () => listeners.delete(l); },
    () => gameBars > 0,
  );
}
